// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .mediasfu-cohost-modal .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .mediasfu-cohost-modal .modal-title {
    font-size: 18px;
    font-weight: bold;
    color: black;
  }
  
  .mediasfu-cohost-modal .btn-close {
    padding: 5px;
    cursor: pointer;
  }
  
  /* Add more styles for modal body, footer, buttons, etc. */
  `, "",{"version":3,"sources":["webpack://./src/components/coHostComponents/CoHostModal.css"],"names":[],"mappings":";EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA,0DAA0D","sourcesContent":["\r\n  .mediasfu-cohost-modal .modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .mediasfu-cohost-modal .modal-title {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    color: black;\r\n  }\r\n  \r\n  .mediasfu-cohost-modal .btn-close {\r\n    padding: 5px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  /* Add more styles for modal body, footer, buttons, etc. */\r\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
